const HISTORY_KEY = 'mendbyte:history-enabled';
const HISTORY_DATA_KEY = 'mendbyte:history';

export interface HistoryEntry {
  timestamp: string;
  format: string;
  operation: string;
  result: string;
  durationMs: number;
  issueCount: number;
}

export function historyEnabled(): boolean {
  return localStorage.getItem(HISTORY_KEY) === 'true';
}

export function setHistoryEnabled(enabled: boolean): void {
  localStorage.setItem(HISTORY_KEY, String(enabled));
  if (!enabled) localStorage.removeItem(HISTORY_DATA_KEY);
}

export function addHistory(entry: HistoryEntry): void {
  if (!historyEnabled()) return;
  const history = readHistory();
  localStorage.setItem(HISTORY_DATA_KEY, JSON.stringify([entry, ...history].slice(0, 50)));
}

export function readHistory(): HistoryEntry[] {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(HISTORY_DATA_KEY) ?? '[]');
    return Array.isArray(parsed) ? (parsed as HistoryEntry[]) : [];
  } catch {
    return [];
  }
}

export function clearLocalData(): void {
  localStorage.removeItem(HISTORY_DATA_KEY);
  localStorage.removeItem(HISTORY_KEY);
}
